import { useLocation } from "react-router"
import { useParams } from "../../../../../../../../router"
import { Breadcrumbs, searchToQuery } from "@sembark-travel/ui/router"
import { generatePath } from "../../../../../../../../router-utils"
import { TSPCompareFiles } from "../../../../../../../../DataDrive/TransportService"
import { Helmet } from "react-helmet-async"

export default function TransportServiceSheetPricesVersionComparePage() {
	const location = useLocation()
	const { folderId, fileId, versionId1, versionId2 } = useParams(
		"/data-drive/folders/:folderId/files/:fileId/compare/:versionId1/:versionId2/transport"
	)
	const query = searchToQuery<{
		file: string
		folder: string
	}>(location && location.search)

	const fileName = query["file"] || ""

	const folderName = query["folder"] || ""

	return (
		<>
			<Helmet>
				<title>Comparison of Transport Service Sheet</title>
			</Helmet>
			<Breadcrumbs
				key={"Transport Service Sheet Prices Compare"}
				title="Transport Service Sheet Prices Compare"
				items={[
					[
						generatePath("/data-drive/folders/:folderId/files/:fileId", {
							folderId,
							fileId,
						}),
						`${folderName || ""}`,
					],
					[
						generatePath(
							"/data-drive/folders/:folderId/files/:fileId/versions/:versionId/view",
							{ folderId, fileId, versionId: versionId1 }
						),
						`${fileName || ""}`,
					],
				]}
			/>
			<TSPCompareFiles
				fileId={fileId}
				versionId1={versionId1}
				versionId2={versionId2}
			/>
		</>
	)
}
